"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.active.help': 'Los avatares inactivos no son visibles para usuarios normales',
};
